<template>
  <div :class="cellClass">
    <div class="flex items-center justify-between">
      <span class="text-xs font-semibold uppercase tracking-wide text-gray-400">
        {{ label }}
        <span v-if="labelSuffix" class="text-gray-400 font-normal">{{ labelSuffix }}</span>
      </span>
      <span v-if="badgeText" class="px-2 py-0.5 rounded-full text-xs font-semibold" :class="badgeClass">
        {{ badgeText }}
      </span>
    </div>
    <div
      class="mt-1 flex min-w-0 flex-col gap-0.5 xl:flex-row xl:items-baseline xl:gap-1.5 xl:whitespace-nowrap xl:overflow-hidden"
    >
      <p class="text-base font-bold" :class="valueClass">{{ value }}</p>
      <span v-if="subtitle" class="text-xs text-gray-500 min-w-0 break-words xl:truncate">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    labelSuffix: { type: String, default: "" },
    value: { type: String, default: "" },
    valueClass: { type: String, default: "text-gray-900" },
    subtitle: { type: String, default: "" },
    badgeText: { type: String, default: "" },
    badgeClass: { type: String, default: "" },
    cellClass: { type: String, default: "" },
  },
};
</script>
